import React, { useEffect } from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../Routes/PrivateRoutes";
import SinistroProvider from "./SinistroContext";
import PesquisarSinistro from "./Events/PesquisarSinistro";
import FormularioSinistro from "./Events/FormularioSinistro";
import { LoadMask } from "../../../Utils/mask";

const Index = () => {
  let match = useRouteMatch();
  useEffect(() => {
    LoadMask();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <SinistroProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarSinistro}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioSinistro}
          />
        </Switch>
      </div>
    </SinistroProvider>
  );
};

export default Index;
